export default __webpack_public_path__ + "static/media/events-cat.c08fee34.webp";